export default function Footer() {
  const scrollTo = (href: string) => {
    if (href === '#') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-white border-t border-[#1A1A1A]/8">
      <div className="max-w-7xl mx-auto px-6 md:px-14 py-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">

          {/* Logo — full color on white bg */}
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); scrollTo('#'); }}
            className="flex-shrink-0 cursor-pointer"
          >
            <img
              src="https://inspectors.com/wp-content/uploads/2022/01/logo.png"
              alt="Inspectors.com — Certified Home Inspections Nationwide"
              className="block object-contain"
              style={{ height: '40px', maxWidth: '190px', minWidth: '120px' }}
            />
          </a>

          {/* Minimal nav */}
          <nav className="flex flex-wrap gap-6">
            {[
              ['Services', '#services'],
              ['How It Works', '#process'],
              ['FAQ', '#faq'],
              ['Contact', '#contact'],
            ].map(([label, href]) => (
              <button
                key={label}
                onClick={() => scrollTo(href)}
                className="text-sm text-[#1A1A1A]/50 hover:text-[#C9A961] transition-colors cursor-pointer whitespace-nowrap"
              >
                {label}
              </button>
            ))}
          </nav>

          {/* Phone */}
          <a
            href="tel:+12814217355"
            className="flex items-center gap-2.5 text-sm font-semibold text-[#1A1A1A] hover:text-[#C9A961] transition-colors whitespace-nowrap"
          >
            <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/10 rounded-full flex-shrink-0">
              <i className="ri-phone-fill text-[#C9A961] text-sm"></i>
            </div>
            (281) 421-7355
          </a>
        </div>
      </div>

      <div className="border-t border-[#1A1A1A]/6">
        <div className="max-w-7xl mx-auto px-6 md:px-14 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#1A1A1A]/32 text-xs">
            &copy; {new Date().getFullYear()} Inspectors.com. All rights reserved.
          </p>
          <div className="flex gap-5">
            <a href="#" rel="nofollow" className="text-[#1A1A1A]/32 text-xs hover:text-[#1A1A1A]/55 transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" rel="nofollow" className="text-[#1A1A1A]/32 text-xs hover:text-[#1A1A1A]/55 transition-colors whitespace-nowrap">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
